<div class="instructions">
  <a (click)="show = !show" class="trigger" [ngClass]="{'opened' : show == true}"><em>How does this work?</em></a>
  <ol *ngIf="show">
    <li>At vero eos et accusamus et iusto odio dignissimos ducimus.</li>
    <li>Temporibus autem quibusdam et aut officiis debitis aut rerum.</li>
    <li> Nam libero tempore, cum soluta nobis est eligendi.</li>
  </ol>
</div>
